import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Image from '../../../shared/Image';
import celebrationIcon from '../../../../../images/icons/icon-celebration.svg';
import Analytics from '../../../../modules/analytics';
import '../Notification.scss';
import './NcdAnnouncementNotification.scss';
import NCDEducationModal from '../../newClientDelivery/NCDEducationModal';
import BodyText from '../../../ui/BodyText';
import ModalTriggerButton from '../../newClientDelivery/ModalTriggerButton';

export const NCD_NOTIFICATION_LEARN_MORE_EVENT = 'ncd_notification_learn_more_clicked';
/**
 * The NCD Announcement notification
 */
const NcdAnnouncementNotification = ({ providerId }) => (
  <button type="button" className="button-notification">
    <section className="notification">
      <div className="icon">
        <Image
          source={{
            uri: celebrationIcon,
            width: 32,
            height: 23,
            resizeMode: 'center',
          }}
        />
      </div>
      <section className="notification-body short-block">
        <div className="notification-text">
          <BodyText weight="bold">New!</BodyText>
          <p className="notification-indent">
            We&apos;re helping you get exposure to new clients.
          </p>
          <ModalTriggerButton
            onClick={() => {
              Analytics.track(NCD_NOTIFICATION_LEARN_MORE_EVENT, {
                pro_id: { providerId },
                time: moment().format(),
              });
            }}
            text="Learn More"
            modalClass={NCDEducationModal}
          />
        </div>
      </section>
    </section>
  </button>
);

NcdAnnouncementNotification.propTypes = {
  providerId: PropTypes.string.isRequired,
};

export default NcdAnnouncementNotification;
